module.exports = __webpack_public_path__ + "d664201f/img/dollar-icon.35c9d638.svg";